export function Nothing() {
    return { kind: 'Nothing' };
}
export function Just(value) {
    return { kind: 'Just', value };
}
export function map(maybe, f) {
    if (maybe.kind === 'Nothing') {
        return Nothing();
    }
    return Just(f(maybe.value));
}
export function justs(xs) {
    let result = [];
    for (let x of xs) {
        if (x.kind === 'Just') {
            result.push(x.value);
        }
    }
    return result;
}
export class BiMap {
    constructor() {
        this.leftToRight = new Map();
        this.rightToLeft = new Map();
    }
    set(left, right) {
        this.leftToRight.set(left, right);
        this.rightToLeft.set(right, left);
    }
    getRight(left) {
        return this.leftToRight.get(left);
    }
    getLeft(right) {
        return this.rightToLeft.get(right);
    }
    hasLeft(left) {
        return this.leftToRight.has(left);
    }
    hasRight(right) {
        return this.rightToLeft.has(right);
    }
}
export function Left(value) {
    return { kind: 'Left', value };
}
export function Right(value) {
    return { kind: 'Right', value };
}
export function range(n) {
    let result = [];
    for (let i = 0; i < n; i++) {
        result.push(i);
    }
    return result;
}
export function flatMap(as, f) {
    let result = [];
    for (let a of as) {
        result.push(...f(a));
    }
    return result;
}
export function sumBy(xs, f) {
    let result = 0;
    for (let x of xs) {
        result += f(x);
    }
    return result;
}
